import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICourse, IActiveCourses } from '@interfaces/ICourse';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CoursesViewService {
  constructor(private _http: HttpClient) {}

  getCourses(qParams?: {
    [key: string]: string | boolean;
  }): Observable<ICourse[]> {
    const url = `${environment.baseUrl}api/v1/courses/`;
    return this._http.get<ICourse[]>(url, { params: qParams });
  }

  getActiveCourses(qParams?: {
    [key: string]: string | boolean;
  }): Observable<IActiveCourses> {
    const url = `${environment.baseUrl}api/v1/courses/active/`;
    return this._http.get<IActiveCourses>(url, { params: qParams });
  }

  getInactiveCourses(): Observable<IActiveCourses> {
    const url = `${environment.baseUrl}api/v1/courses/inactive/`;
    return this._http.get<IActiveCourses>(url);
  }

  getCourseDetail(id: number): Observable<ICourse> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/`;
    return this._http.get<ICourse>(url);
  }
}
